/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SearchRelevanceScoreOrderPressReleaseResponseData,
    SearchRelevanceScoreOrderPressReleaseResponseDataFromJSON,
    SearchRelevanceScoreOrderPressReleaseResponseDataFromJSONTyped,
    SearchRelevanceScoreOrderPressReleaseResponseDataToJSON,
} from './SearchRelevanceScoreOrderPressReleaseResponseData';

/**
 * 
 * @export
 * @interface SearchRelevanceScoreOrderPressReleaseResponse
 */
export interface SearchRelevanceScoreOrderPressReleaseResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchRelevanceScoreOrderPressReleaseResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof SearchRelevanceScoreOrderPressReleaseResponse
     */
    message: string;
    /**
     * 
     * @type {SearchRelevanceScoreOrderPressReleaseResponseData}
     * @memberof SearchRelevanceScoreOrderPressReleaseResponse
     */
    data: SearchRelevanceScoreOrderPressReleaseResponseData;
}

export function SearchRelevanceScoreOrderPressReleaseResponseFromJSON(json: any): SearchRelevanceScoreOrderPressReleaseResponse {
    return SearchRelevanceScoreOrderPressReleaseResponseFromJSONTyped(json, false);
}

export function SearchRelevanceScoreOrderPressReleaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRelevanceScoreOrderPressReleaseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': SearchRelevanceScoreOrderPressReleaseResponseDataFromJSON(json['data']),
    };
}

export function SearchRelevanceScoreOrderPressReleaseResponseToJSON(value?: SearchRelevanceScoreOrderPressReleaseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': SearchRelevanceScoreOrderPressReleaseResponseDataToJSON(value.data),
    };
}

